module.exports = __webpack_public_path__ + "assets/img/w2.ddb355cc.png";